import TaxiCorporationUnbilledOrdersListRequest, {
  TaxiCorporationUnbilledOrdersListRequestOrder,
} from "../../../../api/raily/taxi-corporation/unbilled/orders-list/taxi-corporation-unbilled-orders-list.request";
import UnbilledOrder from "../../../../types/unbilled-order";
import TaxiCorporationUnbilledOrdersListParams from "./taxi-corporation-unbilled-orders-list-params";

const createOrder = (
  order: UnbilledOrder | undefined,
): TaxiCorporationUnbilledOrdersListRequestOrder | undefined => {
  switch (order) {
    case UnbilledOrder.HUMAN_ID_ASC:
      return TaxiCorporationUnbilledOrdersListRequestOrder.HUMAN_ID_ASC;
    case UnbilledOrder.HUMAN_ID_DESC:
      return TaxiCorporationUnbilledOrdersListRequestOrder.HUMAN_ID_DESC;
    case UnbilledOrder.START_TIME_ASC:
      return TaxiCorporationUnbilledOrdersListRequestOrder.START_TIME_ASC;
    case UnbilledOrder.START_TIME_DESC:
      return TaxiCorporationUnbilledOrdersListRequestOrder.START_TIME_DESC;
    default:
      return undefined;
  }
};

const createRequest = (
  params: TaxiCorporationUnbilledOrdersListParams,
): TaxiCorporationUnbilledOrdersListRequest => {
  return {
    taxiCorporationUuid: params.taxiCorporationUuid,
    limit: params.limit,
    address: params.address,
    client: params.client,
    dispatch: params.dispatch,
    driver: params.driver,
    endAddress: params.endAddress,
    excludeCargoCompany: params.excludeCargoCompany,
    externalId: params.externalId,
    humanId: params.humanId,
    isCancelled: params.isCancelled,
    midAddress: params.midAddress,
    offset: params.offset,
    order: createOrder(params.order),
    passenger: params.passenger,
    startAddress: params.startAddress,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
    taxi: params.taxi,
  };
};

const taxiCorporationUnbilledOrdersListParamsFactory = {
  createRequest,
};

export default taxiCorporationUnbilledOrdersListParamsFactory;
